import React from "react";
import { painting } from "../data";

export default function Plays() {
  return (
    <section>
      <div className="container mx-auto ">
        <p className="text-2xl text-center">Original Paintings by Nat TK</p>
      <div className="justify-center  px-10 mx-auto">
        {painting.map((painting) => (
          <div className=" mx-2 my-2">
            <img src={painting.src} alt={painting.alt} />
          </div>
        ))}
      </div>
        </div>
    </section>
  );
}
